module.exports = __webpack_public_path__ + "img/whatsapp.15a5f3d8.svg";